var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.73 7.74456L3.9625 10.9762C4.11877 11.1325 4.3307 11.2202 4.55167 11.2202C4.77264 11.2202 4.98456 11.1325 5.14083 10.9762C5.29706 10.82 5.38482 10.608 5.38482 10.3871C5.38482 10.1661 5.29706 9.95417 5.14083 9.79789L2.17833 6.83373L19.1667 6.83373C19.3877 6.83373 19.5996 6.74593 19.7559 6.58965C19.9122 6.43337 20 6.22141 20 6.00039V6.00039C20 5.77938 19.9122 5.56742 19.7559 5.41114C19.5996 5.25486 19.3877 5.16706 19.1667 5.16706L2.1275 5.16706L5.14083 2.15456C5.21831 2.07717 5.27978 1.98526 5.32172 1.88409C5.36365 1.78293 5.38524 1.67449 5.38524 1.56498C5.38524 1.45546 5.36365 1.34702 5.32172 1.24586C5.27978 1.14469 5.21831 1.05279 5.14083 0.975392C4.98456 0.819167 4.77264 0.731404 4.55167 0.731404C4.3307 0.731404 4.11877 0.819167 3.9625 0.975392L0.729166 4.20789C0.261717 4.67775 -0.000621796 5.31362 -0.000465393 5.9764C-0.00030899 6.63918 0.262329 7.27492 0.73 7.74456Z",
    fill: "#8B8B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.5949f9a6fdece0a6a13a082cd251d7a7.svg";
export { ForwardRef as ReactComponent };